import {baseRequestService} from "../base.ts";
import {EventForwardPost} from "../../types/domain.ts";

export const eventsEventIdForwardPost = (eventId: string, data: EventForwardPost) => baseRequestService({
    url: `/events/${eventId}/forward`,
    method: 'POST',
    data
})